import { create } from "zustand";
import {
    csatDownloadApi,
  csatFeedbackRating,
  deliveryFeedback,
  deliveryFeedbackDownload,
  deliveryFeedbackRating,
  femaleSurveyDownload,
  femaleSurveyFeedback,
  femaleSurveyRating,
  getAllCustomerFeedback,
  getCSATFeedback,
  getTicketFeedback,
  npsFeedback,
  npsFeedbackDownload,
  npsFeedbackRating,
  ticketFeedbackDownload,
  ticketFeedbackRating,
  treatmentFedback,
  treatmentFeedbackDownload,
  treatmentFeedbackRating,
} from "../api";

export const useCustomerFeedback = create((set) => ({
  customerFeedbackData: {},
  isCustomerFeedbackLoading: false,
  isError: false,
  fetchCustomerFeedback: async (sd, ed) => {
    set({ isCustomerFeedbackLoading: true });
    try {
      const response = await getAllCustomerFeedback(sd, ed);
      set({ customerFeedbackData: response.data });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isCustomerFeedbackLoading: false });
    }
  },
}));

export const useCSATFeedback = create((set) => ({
  CSATFeedbackData: {},
  csatRatingData: {},
  csatDownloadData: {},
  csatDownLoading:false,
  csatRatingLoading: false,
  isCSATFeedbackLoading: false,
  isError: false,
  fetchCSATFeedback: async (sd, ed, page) => {
    set({ isCSATFeedbackLoading: true });
    try {
      const response = await getCSATFeedback(sd, ed, page);
      set({ CSATFeedbackData: response.data });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isCSATFeedbackLoading: false });
    }
  },
  fetchCSATFeedbackRating: async (sd, ed) => {
    set({ csatRatingLoading: true });
    try {
      const response = await csatFeedbackRating(sd, ed);
      set({ csatRatingData: response.data });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ csatRatingLoading: false });
    }
  },
  fetchCSATFeedbackDownload: async (sd, ed) => {
    set({ csatDownLoading: true });
    try {
      const response = await csatDownloadApi(sd, ed);
      set({ csatDownloadData: response.data });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ csatDownLoading: false });
    }
  },
}));

export const useTicketFeedback = create((set) => ({
  ticketFeedback: {},
  ticketRatingData: {},
  ticketDownloadData:[],
  ticketDownLoading:false,
  ticketRatingLoading: false,
  isTicketFeedbackLoading: false,
  isError: false,
  fetchTicketFeedback: async (sd, ed, page) => {
    set({ isTicketFeedbackLoading: true });
    try {
      const response = await getTicketFeedback(sd, ed, page);
      set({ ticketFeedback: response.data });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isTicketFeedbackLoading: false });
    }
  },
  fetchTicketFeedbackRating: async (sd, ed) => {
    set({ ticketRatingLoading: true });
    try {
      const response = await ticketFeedbackRating(sd, ed);
      set({ ticketRatingData: response.data });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ ticketRatingLoading: false });
    }
  },
  fetchTicketFeedbackDownload: async (sd, ed) => {
    set({ ticketDownLoading: true });
    try {
      const response = await ticketFeedbackDownload(sd, ed);
      set({ ticketDownloadData: response.data });
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ ticketDownLoading: false });
    }
  },
}));

export const useDeliveryFeedback = create((set) => ({
  deliveryFeedbackData: {},
  deliveryRatingData:{},
  deliveryDownloadData:{},
  delivDownLoading:false,
  deliveryRatingLoading:false,
  delFeedLoading: false,
  isError: false,
  fetchDeliveryFeedback: async (sd, ed, page) => {
    set({ delFeedLoading: true, error: false });
    try {
      const response = await deliveryFeedback(sd, ed, page);
      set({ deliveryFeedbackData: response.data, delFeedLoading: false });
    } catch (error) {
      set({ isError: true, data: [], delFeedLoading: false });
    }
  },
  fetchDeliveryFeedbackRating: async (sd, ed, page) => {
    set({ deliveryRatingLoading: true, error: false });
    try {
      const response = await deliveryFeedbackRating(sd, ed, page);
      set({ deliveryRatingData: response.data, deliveryRatingLoading: false });
    } catch (error) {
      set({ isError: true, data: [], deliveryRatingLoading: false });
    }
  },
  fetchDeliveryFeedbackDownload: async (sd, ed) => {
    set({ deliveryRatingLoading: true, error: false });
    try {
      const response = await deliveryFeedbackDownload(sd, ed);
      set({ deliveryDownloadData: response.data, deliveryRatingLoading: false });
    } catch (error) {
      set({ isError: true, data: [], deliveryRatingLoading: false });
    }
  },
}));

export const useTreatmentFeedback = create((set) => ({
  treatmentFeedback: {},
  treatmentRatingData:{},
  treatmentDownloadData:{},
  treatmentDownloadLoading:false,
  treatRatingLoading:false,
  treatmentLoading: false,
  isError: false,
  fetchTreatmentFeedback: async (sd, ed, page) => {
    set({ treatmentLoading: true, error: false });
    try {
      const response = await treatmentFedback(sd, ed, page);
      set({ treatmentFeedback: response.data, treatmentLoading: false });
    } catch (error) {
      set({ isError: true, data: [], treatmentLoading: false });
    }
  },
  fetchTreatmentFeedbackRating: async (sd, ed) => {
    set({ treatRatingLoading: true, error: false });
    try {
      const response = await treatmentFeedbackRating(sd, ed);
      set({ treatmentRatingData: response.data, treatRatingLoading: false });
    } catch (error) {
      set({ isError: true, data: [], treatRatingLoading: false });
    }
  },
  fetchTreatmentFeedbackDownload: async (sd, ed) => {
    set({ treatmentDownloadLoading: true, error: false });
    try {
      const response = await treatmentFeedbackDownload(sd, ed);
      set({ treatmentDownloadData: response.data, treatmentDownloadLoading: false });
    } catch (error) {
      set({ isError: true, data: [], treatmentDownloadLoading: false });
    }
  },
}));

export const useFemaleFeedback = create((set) => ({
  femaleFeedback: {},
  femaleRatingData: {},
  femaleDownloadData:{},
  femaleDownloadLoading:false,
  femaleRatingLoading:false,
  femaleFeedLoading: false,
  isError: false,
  fetchFemaleFeedback: async (sd, ed, page) => {
    set({ femaleFeedLoading: true, error: false });
    try {
      const response = await femaleSurveyFeedback(sd, ed, page);
      set({ femaleFeedback: response.data, femaleFeedLoading: false });
    } catch (error) {
      set({ isError: true, data: [], femaleFeedLoading: false });
    }
  },
  fetchFemaleFeedbackRating: async (sd, ed) => {
    set({ femaleRatingLoading: true, error: false });
    try {
      const response = await femaleSurveyRating(sd, ed);
      set({ femaleRatingData: response.data, femaleRatingLoading: false });
    } catch (error) {
      set({ isError: true, data: [], femaleRatingLoading: false });
    }
  },
  fetchFemaleFeedbackDownload: async (sd, ed) => {
    set({ femaleDownloadLoading: true, error: false });
    try {
      const response = await femaleSurveyDownload(sd, ed);
      set({ femaleDownloadData: response.data, femaleDownloadLoading: false });
    } catch (error) {
      set({ isError: true, data: [], femaleDownloadLoading: false });
    }
  },
}));

export const useNpsFeedback = create((set) => ({
  npsFeedback: {},
  npsRatingData: {},
  npsDownloadData:{},
  npsDownloadLoading:false,
  npsRatingLoading:false,
  npsFeedLoading: false,
  isError: false,
  fetchNpsFeedback: async (sd, ed, page) => {
    set({ npsFeedLoading: true, error: false });
    try {
      const response = await npsFeedback(sd, ed, page);
      set({ npsFeedback: response.data, npsFeedLoading: false });
    } catch (error) {
      set({ isError: true, data: [], npsFeedLoading: false });
    }
  },
  fetchNpsFeedbackRating: async (sd, ed) => {
    set({ npsRatingLoading: true, error: false });
    try {
      const response = await npsFeedbackRating(sd, ed);
      set({ npsRatingData: response.data, npsRatingLoading: false });
    } catch (error) {
      set({ isError: true, data: [], npsRatingLoading: false });
    }
  },
  fetchNpsFeedbackDownload: async (sd, ed) => {
    set({ npsDownloadLoading: true, error: false });
    try {
      const response = await npsFeedbackDownload(sd, ed);
      set({ npsDownloadData: response.data, npsDownloadLoading: false });
    } catch (error) {
      set({ isError: true, data: [], npsDownloadLoading: false });
    }
  },
}));